var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgIconQuickLink = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 11,
  height: 12,
  viewBox: "0 0 11 12",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M5.5 0L11 5H0zm0 12L11 7H0z",
  fillRule: "evenodd"
})));
export default SvgIconQuickLink;